/**
 * @author Yaochao
 * @date 2021/7/30 12:12
 * @description
 */
import React from "react";

const ZkStatisticsSpace = (props) => {

    const {flexGrow} = props;

    let style = {
        flexGrow: flexGrow > 0 ? flexGrow : 0
    };

    return (
        <ul className={`zkStatisticsSpace ${props.className ? props.className : ''}`}>
            {React.Children.map(props.children, child => {
                return <li style={style}>{child}</li>
            })}
        </ul>
    )
};

export default ZkStatisticsSpace